import React, { useState, useEffect, useRef } from "react";
import Logobgtransparentblack from '../images/DA_NoxZi/Logo-bg-transparent-black.png';
import Logobgblacktwhiterotate from '../images/DA_NoxZi/Logo-bg-black-twhite-rotate.png';
import logoSvgUpResult from '../images/up-result.svg';
import logoSvgUiProof from '../images/ui-proof.svg';
import logoSvgPhoneBento from '../images/phone-bento.svg';
import svgArrowBtn from '../images/arrow-btn.svg';
import homescreentest from '../images/home-page-test.png';
import bgHero from '../images/bg-hero.png';
import portrait from '../images/portrait.jpeg';
import test from '../images/projects/teste.png';
import savoinimauxImgPreview from '../images/projects/savoinimaux-preview.png';
import pacteImgPreview from "../images/projects/pacte-preview.png"
import { Link } from "react-router-dom";
import Footer from "../components/layout/Footer";
import NavBar from "../components/layout/NavBar";
import UnicornScene from "unicornstudio-react";

export default function LandingPage() {
  const [activeProject, setActiveProject] = useState(0);

  const projects = [
    {
      number: "01",
      title: "PACTE",
      category: "Application mobile",
      year: "2025",
      image: pacteImgPreview,
      text: "Fidélité digitale, messagerie, actualités et événements dans un seul écosystème local.",
      tags: ["iOS & Android", "Commerce local", "Fidélité"],
      link: "/projects/pacte",
    },
    {
      number: "02",
      title: "Savoinimaux",
      category: "Site web",
      year: "2025",
      image: savoinimauxImgPreview,
      text: "Refonte complète de l'image digitale d'une association — plus lisible, plus crédible.",
      tags: ["Refonte", "Association", "UX"],
      link: "/projects/savoinimaux",
    },
    {
      number: "03",
      title: "AJ Construction",
      category: "Présence digitale",
      year: "2026",
      image: test,
      text: "Visibilité locale, image professionnelle et cohérence de communication pour un artisan.",
      tags: ["Local", "Image pro", "SEO"],
      link: "/projects/aj-construction",
    },
  ];

  return (
    <div className="relative min-h-screen text-black overflow-hidden bg-white selection:bg-black selection:text-white">

      <div className="absolute inset-0 z-0 h-[100vh] hidden md:block">
        <img
          src={bgHero}
          alt="Background"
          className="w-full h-full object-cover pt-20"
        />
      </div>
      <NavBar />

      {/* ── HERO ──────────────────────────────────────────────────── */}
      <section className="relative text-center pt-20 px-6 py-12 md:py-24 z-10">

        <h1 className="text-2xl leading-[54px] font-asap md:text-4xl font-medium max-w-3xl mx-auto mt-24">
          Parce que chaque{" "}
          <img src={Logobgblacktwhiterotate} alt="Logo" className="inline-block w-16 h-16 align-middle" />{" "}
          vision est unique,
          <br className="hidden md:block" />
          chaque application devrait l'être aussi
        </h1>

        <p className="mt-4 text-[#000000B2] max-w-xl mx-auto font-asap">
          Votre ambition mérite une solution sur mesure. Nous créons l'application
          qui vous ressemble, portée par notre savoir-faire.
        </p>

        <div className="mt-6 flex items-center justify-center gap-4 flex-wrap">
          <a href="mailto:contact@noxzi.fr"
            className="font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform inline-flex items-center">
            Découvrir les services
          </a>
          {/* <a href="https://cal.com/noxzi/30min"
            className="font-asap border border-black/20 text-black px-6 py-2.5 rounded-full hover:bg-black hover:text-white transition-all inline-flex items-center gap-2">
            Réserver un appel
            <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4 text-black" />
          </a> */}
        </div>
        <div className="mt-32 flex justify-center relative">
          <img src={homescreentest} alt="Mobile app preview" className="w-4xl max-h-[456px] md:w-4xl rounded-2xl z-10" />
          <div className="absolute left-0 right-0 top-0 bottom-0 flex justify-center opacity-30 blur-sm z-0">
            <img src={homescreentest} alt="" className="w-72 max-h-[462.03px] md:w-96" />
          </div>
        </div>
      </section>

      <div className="absolute top-[64vh] left-0 w-full h-96 bg-[linear-gradient(180deg,rgba(255,255,255,0)_4.41%,#fff_76.1%)] mix-blend-lighten z-20 pointer-events-none" />

      {/* ── INTRO APPLICATION MOBILE ──────────────────────────────── */}
      <div className="text-left pt-12 px-6 relative z-10">
        <h2 className="font-asap text-5xl md:text-6xl font-[600] mb-6 text-gray-900 max-w-4xl mx-auto">
          Application mobile
        </h2>
        <p className="text-lg md:text-xl text-gray-600 mb-4 max-w-4xl mx-auto leading-relaxed">
          Nous concevons des applications mobiles performantes, robustes et évolutives grâce à React Native.
          Ce framework cross-platform nous permet de développer une seule base de code pour iOS et Android,
          réduisant les coûts tout en garantissant une qualité native et une expérience utilisateur fluide.
        </p>
      </div>

      {/* ── BENTO GRID ────────────────────────────────────────────── */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-[#F3F3F3] rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 flex flex-col justify-between items-center text-center">
              <div className="z-20">
                <h2 className="text-3xl font-[500] font-asap mb-2">Et si on donnait vie à votre application, ensemble ?</h2>
                <p className="text-gray-600 leading-relaxed mt-4">Une approche collaborative, de l'idée initiale jusqu'à la mise en ligne sur les stores.</p>
              </div>
              <div className="w-full flex justify-center items-end z-10">
                <img src={logoSvgPhoneBento} alt="Phone bento" className="object-contain w-[90%]" />
              </div>
            </div>

            <div className="grid grid-rows-2 gap-6">
              <div className="bg-[#F3F3F3] rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden">
                <div className="h-48 mb-6 flex items-center justify-center relative">
                  <div className="relative flex items-end justify-center h-48 -mb-12">
                    <img src={logoSvgUpResult} alt="Résultats" className="h-44 object-contain z-10" />
                  </div>
                </div>
                <div className="font-asap bg-white p-4" style={{ boxShadow: 'inset 0px -10px 25px -3px rgba(0,0,0,0.15)' }}>
                  <h2 className="text-2xl font-[500] mb-4 text-gray-900">Conçues pour performer</h2>
                  <p className="text-gray-600 leading-relaxed">Parce que vos besoins sont uniques, nos choix techniques visent des applications efficaces, rapides et durables.</p>
                </div>
              </div>

              <div className="bg-[#F3F3F3] rounded-3xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 relative overflow-hidden">
                <div className="h-48 mb-6 flex items-center justify-center relative">
                  <div className="relative flex items-end justify-center h-60">
                    <img src={logoSvgUiProof} alt="UI Design" className="h-54 object-contain z-10" />
                  </div>
                </div>
                <div className="font-asap bg-white p-4" style={{ boxShadow: 'inset 0px -10px 25px -3px rgba(0,0,0,0.15)' }}>
                  <h2 className="text-2xl font-[500] mb-4 text-gray-900">Un design pensé à 360°</h2>
                  <p className="text-gray-600 leading-relaxed">Nous concevons des interfaces complètes et cohérentes, pensées pour refléter votre identité.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-right max-w-4xl mx-auto">
          <a href="https://cal.com/noxzi/30min"
            className="mt-6 inline-flex font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform">
            Commencer mon projet
          </a>
        </div>
      </section>

      {/* ── ACCOMPAGNEMENT HUMAIN ─────────────────────────────────── */}
      <section className="max-w-7xl mx-auto px-6 py-24 grid gap-12 md:grid-cols-2 items-center">
        <div className="relative w-full max-w-md mx-auto group">
          <div className="absolute top-3 left-3 w-full h-full rounded-2xl bg-white shadow-md rotate-3 transition-all duration-300 ease-in-out group-hover:rotate-0 z-0 group-hover:top-0 group-hover:left-0" />
          <div className="relative z-10 overflow-hidden rounded-2xl -rotate-3 hover:rotate-0 transition-all duration-300 ease-in-out shadow-[0_9px_10px_rgba(0,0,0,0.25),inset_0_2px_7.3px_#ffffff]">
            <img src={portrait} alt="Notre équipe" className="w-full h-[70vh] object-cover rounded-2xl" />
            <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-white to-transparent px-4 py-3 flex items-end">
              <p className="text-sm font-asap text-black font-medium">Un accompagnement humain</p>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#b98c42] mb-5">Notre approche</p>
          <h2 className="text-3xl font-semibold font-asap">Un accompagnement humain, du premier échange jusqu'à la mise en ligne.</h2>
          <p className="text-gray-600 leading-relaxed font-asap">
            Chez nous, chaque projet commence par une écoute attentive.<br />
            Nous vous conseillons à chaque étape : design, développement, choix techniques, et évolutions futures.
          </p>
          <a href="https://cal.com/noxzi/30min"
            className="inline-flex font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform">
            Parler de mon projet
          </a>
        </div>
      </section>

      {/* ── NOS PROJETS — interactive hover ───────────────────────── */}
      <section className="py-24 px-6 bg-[#0e0e0e] text-white overflow-hidden">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-end justify-between mb-16">
            <div>
              <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#d1a75f] mb-3">Nos projets</p>
              <h2 className="font-asap text-4xl md:text-5xl font-[600] leading-[1.05]">
                Des réalisations<br />avec exigence
              </h2>
            </div>
            <Link to="/projects"
              className="hidden md:inline-flex items-center gap-2 font-asap text-[13px] border border-white/15 px-5 py-2.5 rounded-full hover:bg-white hover:text-black transition-all shrink-0">
              Tous les projets <span>→</span>
            </Link>
          </div>

          {/* Desktop: interactive list + floating image */}
          <div className="hidden md:grid grid-cols-[1fr_420px] gap-12 items-start">
            <div>
              {projects.map((p, i) => (
                <button
                  key={p.title}
                  onMouseEnter={() => setActiveProject(i)}
                  onClick={() => setActiveProject(i)}
                  className="w-full text-left group"
                >
                  <Link to={p.link} className="block">
                    <div className={`flex items-center gap-6 py-7 border-b transition-all duration-300 ${activeProject === i ? 'border-white/20' : 'border-white/8'}`}>
                      <span className={`text-[11px] tabular-nums transition-colors duration-300 w-6 shrink-0 ${activeProject === i ? 'text-[#d1a75f]' : 'text-white/25'}`}>{p.number}</span>
                      <div className="flex-1">
                        <div className="flex items-baseline gap-4 mb-2">
                          <h3 className={`font-asap font-[600] text-[1.8rem] leading-none transition-all duration-300 ${activeProject === i ? 'text-white' : 'text-white/40'}`}>{p.title}</h3>
                          <span className={`text-[11px] uppercase tracking-[0.14em] transition-colors duration-300 ${activeProject === i ? 'text-[#d1a75f]' : 'text-white/20'}`}>{p.category}</span>
                        </div>
                        <p className={`font-asap text-[14px] leading-relaxed transition-all duration-300 max-w-md ${activeProject === i ? 'text-white/60 max-h-20 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>{p.text}</p>
                      </div>
                      <span className={`text-lg transition-all duration-300 ${activeProject === i ? 'text-white translate-x-1' : 'text-white/10'}`}>→</span>
                    </div>
                  </Link>
                </button>
              ))}
            </div>

            {/* Floating image */}
            <div className="sticky top-24">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-white/5">
                {projects.map((p, i) => (
                  <img
                    key={p.title}
                    src={p.image}
                    alt={p.title}
                    className={`absolute inset-0 w-full h-full object-cover transition-all duration-500 ${activeProject === i ? 'opacity-100 scale-100' : 'opacity-0 scale-[1.03]'}`}
                  />
                ))}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  {projects.map((p, i) => (
                    <div key={p.title} className={`transition-all duration-300 ${activeProject === i ? 'opacity-100' : 'opacity-0 absolute'}`}>
                      <div className="flex flex-wrap gap-2 mb-3">
                        {p.tags.map(tag => (
                          <span key={tag} className="text-[11px] bg-white/15 backdrop-blur-sm text-white px-3 py-1 rounded-full font-asap">{tag}</span>
                        ))}
                      </div>
                      <Link to={p.link} className="inline-flex items-center gap-2 bg-white text-black text-[13px] font-asap font-medium px-5 py-2.5 rounded-full hover:opacity-90 transition-opacity">
                        Voir le projet <span>→</span>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Mobile: stacked cards */}
          <div className="md:hidden space-y-4">
            {projects.map((p) => (
              <Link key={p.title} to={p.link} className="block rounded-2xl overflow-hidden relative group">
                <img src={p.image} alt={p.title} className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-[#d1a75f] mb-1 font-asap">{p.category} · {p.year}</p>
                  <h3 className="font-asap font-[600] text-white text-xl">{p.title}</h3>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 md:hidden">
            <Link to="/projects" className="inline-flex items-center gap-2 font-asap text-[13px] border border-white/15 px-5 py-2.5 rounded-full text-white hover:bg-white hover:text-black transition-all">
              Tous les projets <span>→</span>
            </Link>
          </div>
        </div>
      </section>

      {/* ── CHIFFRES / PREUVES SOCIALES ───────────────────────────── */}
      <section className="py-20 px-6 border-b border-black/6">
        <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { value: "3+", label: "Projets livrés" },
            { value: "100%", label: "Cross-platform" },
            { value: "2", label: "Ans d'expérience" },
            { value: "∞", label: "Évolutivité" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-asap text-[3rem] md:text-[4rem] font-[600] leading-none tracking-[-0.04em] text-black mb-2">{stat.value}</p>
              <p className="font-asap text-[13px] text-black/40 uppercase tracking-[0.14em]">{stat.label}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── EXPERTISES — sticky scroll ─────────────────────────────── */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto grid md:grid-cols-[1fr_1.2fr] gap-16 items-start">
          <div className="md:sticky md:top-24">
            <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#b98c42] mb-4">Nos expertises</p>
            <h2 className="font-asap text-4xl md:text-5xl font-[600] text-gray-900 leading-[1.05] mb-6">Bien plus qu'une simple application</h2>
            <p className="text-gray-500 font-asap leading-relaxed text-[15px] mb-8">
              Applications mobiles, sites web ou écosystèmes complets — pensés pour évoluer dans le temps.
            </p>
            <a href="https://cal.com/noxzi/30min"
              className="inline-flex items-center gap-2 font-asap text-[13px] font-medium bg-black text-white px-5 py-2.5 rounded-full hover:opacity-80 transition-opacity">
              En discuter <span>→</span>
            </a>
          </div>
          <div className="space-y-0">
            {[
              { label: "Applications mobiles iOS & Android", desc: "React Native · Cross-platform" },
              { label: "Sites web sur mesure", desc: "Design · Développement" },
              { label: "UI / UX Design", desc: "Prototypage · Cohérence visuelle" },
              { label: "Interfaces d'administration", desc: "Dashboard · Back-office" },
              { label: "Identité visuelle digitale", desc: "Image de marque · Direction artistique" },
              { label: "Accompagnement produit", desc: "Stratégie · Roadmap · Suivi" },
            ].map((item, i) => (
              <div key={item.label} className="flex items-center justify-between gap-4 py-5 border-b border-black/6 group cursor-default hover:pl-2 transition-all duration-200">
                <div>
                  <p className="font-asap font-[500] text-[15px] text-gray-900 group-hover:text-[#9a7130] transition-colors">{item.label}</p>
                  <p className="font-asap text-[12px] text-gray-400 mt-0.5">{item.desc}</p>
                </div>
                <span className="text-[11px] tabular-nums text-black/20 shrink-0">0{i + 1}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── PROCESSUS — fond noir, grille ─────────────────────────── */}
      <section className="py-24 px-6 bg-[#0e0e0e] text-white">
        <div className="max-w-4xl mx-auto">
          <div className="mb-16">
            <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#d1a75f] mb-4">Notre méthode</p>
            <h2 className="font-asap text-4xl md:text-5xl font-[600] leading-[1.05] max-w-lg">Une méthode claire, exigeante et maîtrisée</h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-white/8">
            {[
              { step: "01", title: "Échange & cadrage", text: "Analyse du besoin, de la cible et de la direction produit à construire ensemble.", icon: "◎" },
              { step: "02", title: "Design & prototype", text: "Interface claire, élégante et fidèle à votre image — validée avec vous avant le dev.", icon: "◈" },
              { step: "03", title: "Développement", text: "Base technique propre, robuste et évolutive — code soigné et bien architecturé.", icon: "◉" },
              { step: "04", title: "Lancement & suivi", text: "Accompagnement jusqu'à la mise en ligne et présence continue pour les évolutions.", icon: "◌" },
            ].map((item) => (
              <div key={item.step} className="bg-[#0e0e0e] p-10 hover:bg-white/[0.03] transition-colors duration-300 group">
                <div className="flex items-start justify-between mb-8">
                  <span className="font-asap text-[11px] uppercase tracking-[0.22em] text-[#d1a75f]">{item.step}</span>
                  <span className="text-white/10 text-2xl group-hover:text-white/20 transition-colors">{item.icon}</span>
                </div>
                <h3 className="font-asap font-[500] text-[1.3rem] text-white mb-3 leading-snug">{item.title}</h3>
                <p className="text-white/40 text-[13px] font-asap leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 flex justify-end">
            <a href="https://cal.com/noxzi/30min"
              className="inline-flex items-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium hover:bg-[#f5f0e8] transition-colors">
              Démarrer un projet
              <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>

      {/* ── TECHNOLOGIE ───────────────────────────────────────────── */}
      <section className="py-24 px-6 bg-[#f7f6f3]">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          <div>
            <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#b98c42] mb-4">Technologie</p>
            <h2 className="font-asap text-4xl md:text-5xl font-[600] text-gray-900 leading-[1.05] mb-6">Une stack moderne, pensée pour durer</h2>
            <p className="text-gray-500 font-asap leading-relaxed text-[15px] mb-10">
              Des technologies fiables et maintenables, pour un produit capable d'évoluer avec votre activité.
            </p>
            <div className="flex flex-wrap gap-3">
              {["React Native", "iOS & Android", "Firebase", "UI/UX Design", "API & Back-end", "Stores"].map((tech) => (
                <span key={tech} className="font-asap text-[13px] font-[500] bg-white border border-black/8 px-4 py-2 rounded-full shadow-sm text-gray-800 hover:-translate-y-0.5 transition-transform cursor-default">
                  {tech}
                </span>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-3xl p-8 shadow-lg border border-black/5">
            <div className="w-12 h-12 rounded-xl bg-black flex items-center justify-center mb-6">
              <img src={Logobgtransparentblack} alt="NoxZi" className="w-7 h-7 object-contain invert" />
            </div>
            <p className="font-asap uppercase tracking-[0.22em] text-[10px] text-[#b98c42] mb-3">Notre engagement</p>
            <h3 className="font-asap font-[500] text-[1.3rem] text-gray-900 mb-4 leading-snug">Des choix techniques conçus pour soutenir votre croissance</h3>
            <p className="text-gray-500 font-asap leading-relaxed text-[14px] mb-6">
              Performance, maintenabilité, évolutivité — chaque décision est prise pour garantir une application fiable aujourd'hui et demain.
            </p>
            <a href="https://cal.com/noxzi/30min"
              className="inline-flex items-center gap-2 font-asap text-[13px] font-medium bg-black text-white px-5 py-2.5 rounded-full hover:opacity-80 transition-opacity">
              Échanger <span>→</span>
            </a>
          </div>
        </div>
      </section>

      {/* ── POURQUOI NOUS ─────────────────────────────────────────── */}
      <section className="py-24 px-6">
        <div className="max-w-4xl mx-auto">
          <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#b98c42] mb-4">Pourquoi nous</p>
          <h2 className="font-asap text-4xl md:text-6xl font-[600] text-gray-900 leading-[1.02] mb-16 max-w-2xl">Plus qu'un prestataire, un partenaire produit</h2>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              { index: "01", title: "Vision produit", text: "Nous construisons une solution cohérente, utile et pensée pour les usages réels." },
              { index: "02", title: "Exigence design", text: "Chaque interface est travaillée avec précision pour un rendu premium et fidèle à votre identité." },
              { index: "03", title: "Accompagnement réel", text: "Présents avant, pendant et après le lancement pour faire évoluer votre application." },
            ].map((item) => (
              <div key={item.title} className="border-t-2 border-black/8 pt-6 hover:border-[#b98c42]/40 transition-colors duration-300 group">
                <p className="font-asap text-[11px] text-black/25 tabular-nums mb-4">{item.index}</p>
                <h3 className="font-asap font-[600] text-[1.15rem] text-gray-900 mb-3 group-hover:text-[#9a7130] transition-colors">{item.title}</h3>
                <p className="text-gray-500 font-asap leading-relaxed text-[14px]">{item.text}</p>
              </div>
            ))}
          </div>

          <div className="mt-14">
            <a href="https://cal.com/noxzi/30min"
              className="inline-flex font-asap bg-black text-white px-6 py-2.5 rounded-full shadow-[0_9px_10px_rgba(0,0,0,0.25),_inset_0_2px_7.3px_#ffffff] hover:scale-[1.05] transition-transform">
              Parlons de votre projet
            </a>
          </div>
        </div>
      </section>

      {/* ── TEMOIGNAGES (section bonus) ───────────────────────────── */}
      <section className="py-20 px-6 bg-[#f7f6f3]">
        <div className="max-w-4xl mx-auto">
          <p className="font-asap uppercase tracking-[0.28em] text-[11px] text-[#b98c42] mb-12">Ce qu'ils en disent</p>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              {
                quote: "Nous avons fait appel à NoxZi pour notre projet, pour que Noé puisse developper une application ainsi que retravailler notre site web. Le travail de Noé est excellent, il est rigoureux, professionnel et ponctuel par rapport aux délais. Le résultat est meilleur que ce que nous espérions ! Noé est capable de prendre des initiatives pour nous proposer différents points de vue, dans l’objectif d’un résultat final optimal. Je recommande grandement !!",
                name: "Martin Colas-roy, ",
                role: "Directeur Général de PACTE",
              },
              {
                quote: "Notre association avait lancé un appel à offre pour une refonte internet, et Noé a répondu présent avec enthousiasme et professionnalisme. Il travaille avec nous depuis quelques mois maintenant afin d'optimiser notre site internet. C'est une personne agréable, disponible, créatif, et qui comprend et exécute les instructions remises, tout en donnant de sérieux feedbaclks afin de nous aiguiller au mieux. Nous recommandons et continueront de travailler avec lui.",
                name: "Savoinimaux",
                role: "Association",
              },
              {
                quote: "Très à l écoute et réactif, prestation de qualité. Ravi d'avoir pu travailler avec ce partenaire sur mon projet et ceux à venir.",
                name: "Vitor Costa Fernandez",
                role: "Dirigeant Aj Construction 2 Savoie"
              },
            ].map((t) => (
              <div key={t.name} className="bg-white rounded-3xl p-8 shadow-sm border border-black/5">
                <p className="font-asap text-[15px] text-gray-700 leading-relaxed mb-6 italic">"{t.quote}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-full bg-[#f0ebe0] flex items-center justify-center">
                    <span className="text-[#b98c42] text-[11px] font-asap font-[600]">{t.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="font-asap font-[500] text-[13px] text-gray-900">{t.name}</p>
                    <p className="font-asap text-[11px] text-gray-400">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA FINAL ─────────────────────────────────────────────── */}
      <section className="py-16 px-6 pb-36">
        <div className="max-w-4xl mx-auto">
          <div className="relative overflow-hidden rounded-3xl bg-black text-white px-8 py-14 md:px-12 md:py-20 shadow-[0_9px_10px_rgba(0,0,0,0.25),inset_0_2px_7.3px_rgba(255,255,255,0.04)]">
            <div className="absolute inset-0 opacity-[0.08]">
              <img src={bgHero} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(201,163,95,0.18),transparent_30%)]" />
            <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#c9a35f]/45 to-transparent" />

            <div className="relative z-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
              <div className="max-w-2xl">
                <p className="font-asap uppercase tracking-[0.34em] text-[11px] text-[#d1a75f] mb-5">Prêt à démarrer ?</p>
                <h2 className="text-4xl md:text-6xl font-[600] font-asap leading-[1.02] mb-5">Donnons forme à votre prochain projet digital</h2>
                <p className="text-white/65 text-[17px] font-asap leading-relaxed">
                  Application mobile, site web ou produit digital plus complet — nous concevons des expériences solides, élégantes et pensées pour durer.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 shrink-0">
                <a href="https://cal.com/noxzi/30min"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-white text-black px-7 py-3.5 font-asap font-medium transition-all duration-300 hover:scale-[1.04]">
                  Réserver un appel
                  <img src={svgArrowBtn} alt="Arrow" className="w-4 h-4" />
                </a>
                <a href="mailto:contact@noxzi.fr"
                  className="inline-flex items-center justify-center rounded-full border border-white/[0.18] px-7 py-3.5 font-asap font-medium text-white transition-all duration-300 hover:bg-white hover:text-black">
                  Nous contacter
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}